import React, { Component } from 'react';
import { authentication } from '../../services/Authentication';
import { config } from '../../Constants';
import helpers from '../../Function';
import moment from 'moment';
import { withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import HeaderTab from "./Header";

class DoneCase extends Component {
    constructor(props) {
        super(props);
        const { jwt, user_permission } = authentication.currentUserValue;
        this.state = {
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            project_home: [],
            service_category: [],
            service_type: [{ value: '', display: 'เลือกเรื่องย่อ' }],
            modalIsOpen: false,
            adv_startdate: '',
            adv_enddate: '',
            adv_member: '',
            adv_phone: '',
            adv_project: '',
            adv_home_number: '',
            adv_status: '',
            adv_category: '',
            adv_title: '',
            adv_service_status: '',
            page: 0,
            rowsPerPage: 10,
            selectServiceType: '',
            service_group: [{ value: '', display: 'เลือกกลุ่ม' }],
            adv_group: ""
        }

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.clearModal = this.clearModal.bind(this);

        this.submitModal = this.submitModal.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.change = this.change.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': jwt,
            },
        };

        fetch(config.url.API_URL + '/project_homes', requestOptions)
            .then(res => res.json())
            .then(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                let FromApi = data.data.map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });
                this.setState({
                    project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                });
            }).catch(err => {
                console.log(`error durring project_homes`)
                console.log(err)
                this.setState({
                    project_home: [{ value: '', display: 'เลือกโครงการ' }]
                });
            });

        fetch(config.url.API_URL + '/service_categorys', requestOptions)
            .then(res => res.json())
            .then(async data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                let FromApi = data.data.filter(item => item.id != '5e232c684d59a834545e911b').map(datas => {
                    return {value: datas.id, display: datas.name_th, type: "service" }
                });

                const juristicCategoryFromAPI = await (await fetch(config.url.API_URL + '/juristic_categorys/?activestatus=1', requestOptions)).json()
                            
                let juristicCategoryFromApi = juristicCategoryFromAPI.data.map(datas => {
                    return {value: datas._id, display: datas.name_th, type: 'juristic' }
                });
                
                this.setState({
                    service_category: [{ value: '', display: 'เลือกหมวดเรื่อง', type: '' }].concat(FromApi, juristicCategoryFromApi)
                });
            }).catch(err => {
                this.setState({
                    service_category: [{ value: '', display: 'เลือกหมวดเรื่อง', type: '' }]
                });
            });

        this.datatable()
    }

    clearModal() {
        this.setState({
            adv_startdate: '',
            adv_enddate: '',
            adv_member: '',
            adv_phone: '',
            adv_project: '',
            adv_home_number: '',
            adv_status: '',
            adv_category: '',
            adv_title: '',
            adv_service_status: '',
            adv_group: '',
            service_group: [{ value: '', display: 'เลือกกลุ่ม' }],
            service_type: [{ value: '', display: 'เลือกเรื่องย่อ' }],
        });
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }
    
    datatable() {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        const serviceComplaintPromise = fetch(config.url.API_URL + '/service_complaints/?pagename=donecase', requestOptions)
        const JurPromise = fetch(config.url.API_URL + '/juristics/?pagename=donecase', requestOptions)
        const data = []

        Promise.all([serviceComplaintPromise, JurPromise]).then( async (result) => {
            const serviceKeyRef = ["service_categorys", "juristic_categorys"]
            for (let i = 0; i < result.length; i++ ) {
                const resultItem = await result[i].json()
                for(let j = 0; j < resultItem.data.length; j ++ ) {
                    const datas = resultItem.data[j]
                    console.log(`dadadadadd`, datas)

                    const columnRef = Object.keys(datas)
                    const categoryName = datas[serviceKeyRef.filter(item =>  columnRef.includes(item))][0].name_th

                    data.push({
                        id: datas._id,
                        number: datas.service_number,
                        service_date: moment(datas.created).format('DD/MM/YYYY'),
                        service_time: moment(datas.created).format('H:mm'),
                        created: datas.created,
                        member_name: datas.member_first_name + ' ' + datas.member_last_name,
                        phone_come: datas.income_phone,
                        project_name: (Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : ''),
                        home_number: datas.home_number,
                        project_status: helpers.getProjectStatus(datas.project_status),
                        // category: (Array.isArray(datas.service_categorys) && datas.service_categorys.length ? datas.service_categorys[0].name_th : ''),
                        category: categoryName,
                        warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + '-' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                        title: (Array.isArray(datas.service_types) && datas.service_types.length ? datas.service_types[0].name_th : ''),
                        contact: helpers.getContactChannel(datas.contact_chanel),
                        service_status: helpers.getServiceStatus2(datas.service_status),
                        sla: helpers.getSla(moment(datas.sla_start_date), moment(datas.sla_end_date), datas.service_status),
                        express: datas.express,
                    })
                }
            }

            const sortedData = await data.sort((a,b) => new Date(a.created) > new Date(b.created) ? -1 : 1)

            this.setState({
                pages: sortedData
            })
        }).catch(err => {
            this.setState({
                pages:[]
            })
        })
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });

        if (e.target.name == "adv_category") {
            if(!e.target.value) {
                this.setState({
                    service_group: [{ value: '', display: 'เลือกกลุ่ม' }],
                    service_type: [{ value: '', display: 'เลือกกลุ่ม' }]
                })
                return;
            }
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            const complaint_service_group = fetch(config.url.API_URL + '/service_groups/?catyid=' + e.target.value, requestOptions)
            const juristic_service_group = fetch(config.url.API_URL + '/juristic_groups/?categoryid=' + e.target.value, requestOptions)

            const refId = e.target.value
            const currentServiceType = this.state.service_category.filter(item => item.value == refId)[0].type

            Promise.all([complaint_service_group, juristic_service_group]).then(async result => {
                const filterOnlyErrStatus = result.filter(item => item.status != 200)
                if(filterOnlyErrStatus.length > 0) throw Error(filterOnlyErrStatus)
                let serviceGroups = []

                for(let i = 0; i < result.length ; i ++) {
                    const response = await result[i].json()
                    if(response.data.length > 0) {
                        serviceGroups = response.data.map(item => {
                            return { value: item.id , display: item.name_th }
                        })
                    }

                }


                this.setState({
                    service_group: [{ value: '', display: 'เลือกกลุ่ม' }].concat(serviceGroups),
                    selectServiceType: currentServiceType
                })

            }).catch(err => {
                console.log(`catch error durring fetch category`)
                console.log(err)
                this.setState({
                    service_group: [{ value: '', display: 'เลือกกลุ่ม' }]
                })
            })

        }

        if (e.target.name == "adv_group") {
            if(!e.target.value) {
                this.setState({
                    service_type: [{ value: '', display: 'เลือกกลุ่ม' }]
                })
                return;
            }

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            const complaint_service_type = fetch(config.url.API_URL + '/service_types/?categoryid=' + this.state.adv_category + '&sortnameth=1&servicegroupid=' + e.target.value, requestOptions)
            const juristic_service_type = fetch(config.url.API_URL + '/juristic_types/?categoryid=' + this.state.adv_category + '&sortnameth=1&servicegroupid=' + e.target.value, requestOptions)

            Promise.all([complaint_service_type, juristic_service_type]).then(async (result) => {
                const filterOnlyErrStatus = result.filter(item => item.status != 200)

                if(filterOnlyErrStatus.length > 0) throw Error(filterOnlyErrStatus)
                let serviceTypes = []

                for(let i = 0; i < result.length ; i ++) {
                    const response = await result[i].json()
                    if(response.data.length > 0) {
                        console.log(`response`, response)
                        serviceTypes = response.data.map(item => {
                            return { value: item.id, display: item.name_th }
                        })
                    }
                }

                console.log(`fetched data`, serviceTypes)

                this.setState({
                    service_type: [{ value: '', display: 'เลือกกลุ่ม' }].concat(serviceTypes),
                })

            }).catch(err => {
                console.log(`catch error durring fetch service_types`)
                console.log(err)
                this.setState({
                    service_type: [{ value: '', display: 'เลือกกลุ่ม' }]
                })
            })
        }

    }

    changeStartDate = date => {
        this.setState({
            adv_startdate: date
        });
    }

    changeEndDate = date => {
        this.setState({
            adv_enddate: date
        });
    }

    openModal() {
        this.setState({ 
            modalIsOpen: true, 
            service_group: [{ value: '', display: 'เลือกกลุ่ม' }],
            adv_category:'',
            adv_enddate: '',
            adv_group: '',
            adv_home_number:'',
            adv_member: '',
            adv_phone: '',
            adv_project: '',
            adv_service_status: '',
            adv_startdate: '',
            adv_status: '',
            adv_title: '',
        });
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleDetail(e) {
        var data = { id: e.currentTarget.attributes["id"].value, page: "donecase" }
        //alert(e.currentTarget.attributes["id"].value);
        //this.props.history.push("/detail-case", { ...data })
        //this.props.history.push("/detail-case", data)
        this.props.history.push({
            pathname: '/detail-case/' + e.currentTarget.attributes["id"].value,
            //search: '?query=abc',
            state: { detail: data }
        })
    }

    async submitModal(e) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        var params = "&startdate=" + (this.state.adv_startdate ? this.state.adv_startdate : '');
        params += "&enddate=" + (this.state.adv_enddate ? this.state.adv_enddate : '');
        params += "&name=" + this.state.adv_member;
        params += "&phone=" + this.state.adv_phone;
        params += "&projecthomeid=" + this.state.adv_project;
        params += "&houseno=" + this.state.adv_home_number;
        params += "&status=" + this.state.adv_status;
        params += "&category=" + this.state.adv_category;
        params += "&servicestatus=" + this.state.adv_service_status;
        params += "&servicetypeid=" + this.state.adv_title;

        const juristicsData = fetch(config.url.API_URL + '/juristics/?pagename=donecase'+ params, requestOptions) 
        const serviceComplaintData = fetch(config.url.API_URL + '/service_complaints/?pagename=donecase'+ params, requestOptions)
        

        Promise.all([juristicsData, serviceComplaintData]).then(async (response) => {
            const filterErrorStatus = response.filter(item => item.status != 200)

            if(filterErrorStatus.length > 0)  throw Error(filterErrorStatus)
            
            let arrData = []
            for(let i = 0 ; i < response.length; i++) {
                const responseData = await response[i].json()
                responseData.data.map(datas => {
                    arrData.push({
                        id: datas._id,
                        number: datas.service_number,
                        service_date: moment(datas.created).format('DD/MM/YYYY'),
                        service_time: moment(datas.created).format('H:mm'),
                        member_name: datas.member_first_name + ' ' + datas.member_last_name,
                        phone_come: datas.income_phone,
                        project_name: datas.project_homes[0].name_th,
                        home_number: datas.home_number,
                        project_status: helpers.getProjectStatus(datas.project_status),
                        // category: this.state.selectServiceType == 'juristic' ? datas.juristic_categorys[0].name_th : datas.service_categorys[0].name_th,
                        category:  Array.isArray(datas.juristic_categorys) && datas.juristic_categorys.length > 0 ? datas.juristic_categorys[0].name_th : datas.service_categorys[0].name_th,
                        warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + ' - ' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                        title: (Array.isArray(datas.service_types) && datas.service_types.length ? datas.service_types[0].name_th : ''),
                        contact: helpers.getContactChannel(datas.contact_chanel),
                        service_status: helpers.getServiceStatus2(datas.service_status),
                        express: datas.express,
                        created: datas.created
                    })

                })
            }

            this.setState({
                pages: [].concat(arrData.sort((a, b) => a.created > b.created ? -1 : 1))
            });

        }).catch(err => {
            console.log(`err`)
            console.log(err)
            this.setState({
                pages: []
            });
        })
        
        this.setState({
            modalIsOpen: false 
        });   
        this.clearModal()
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:hover' :{
                    cursor:'auto'
                }
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Perfect Service</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Perfect Service</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                <HeaderTab />
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-left m-0" style={{width: "125px"}}><span>SLA</span> <div className="status" /> เร่งด่วน</div>
                                    <div className="btn-add text-center m-0" onClick={this.openModal}>ค้นหาขั้นสูง</div>
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table className={StyledTableCell} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>เลขที่</StyledTableCell>
                                                    <StyledTableCell>วันที่รับเรื่อง</StyledTableCell>
                                                    <StyledTableCell>ผู้แจ้ง</StyledTableCell>
                                                    <StyledTableCell>เบอร์โทรผู้แจ้ง</StyledTableCell>
                                                    <StyledTableCell>โครงการ</StyledTableCell>
                                                    <StyledTableCell>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell>สถานะ</StyledTableCell>
                                                    <StyledTableCell>เรื่อง</StyledTableCell>
                                                    <StyledTableCell>ระยะเวลาประกัน</StyledTableCell>
                                                    <StyledTableCell>สถานะใบงาน</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map(data => {
                                                            return (
                                                                // <StyledTableRow data-href="" id={data.id} onClick={this.handleDetail} className={data.sla}>
                                                                <StyledTableRow data-href="" id={data.id} className={['no-hover', data.sla]}>
                                                                    <StyledTableCell><span className={(data.express && "text-express" || "text-default")}>{data.number}</span></StyledTableCell>
                                                                    <StyledTableCell>{data.service_date} {data.service_time}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone_come}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.home_number}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_status}</StyledTableCell>
                                                                    <StyledTableCell>{data.category}</StyledTableCell>
                                                                    <StyledTableCell>{data.warranty_date}</StyledTableCell>
                                                                    <StyledTableCell style={{textAlign:'center'}}>{data.service_status}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }
                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                    <Modal show={this.state.modalIsOpen} onHide={this.closeModal} size="lg">
                        <ModalHeader>
                            <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            {this.state.matches && (<form>
                                <div className="row mb-3 mt-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">วันที่รับเรื่อง-เริ่มต้น :</div>
                                    <div className="col-sm-7">
                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.adv_startdate} id="adv_startdate" name="adv_startdate" className="form-custom" onChange={this.changeStartDate} dateFormat="dd/MM/yyyy" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">วันที่รับเรื่อง-สิ้นสุด :</div>
                                    <div className="col-sm-7">
                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.adv_enddate} id="adv_enddate" name="adv_enddate" className="form-custom" onChange={this.changeEndDate} dateFormat="dd/MM/yyyy" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">ผู้แจ้ง :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_member" name="adv_member" value={this.state.adv_member || ''} onChange={this.change} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">เบอร์โทรผู้แจ้ง :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_phone" name="adv_phone" value={this.state.adv_phone || ''} onChange={this.change} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">โครงการ :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_project" onChange={this.change} value={this.state.adv_project || ''}>
                                            {this.state.project_home.map((datas, key) => <option key={key} value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">บ้านเลขที่ :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_home_number" name="adv_home_number" value={this.state.adv_home_number || ''} onChange={this.change} />
                                    </div>
                                </div>
                                {/* <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">สถานะ :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_status" onChange={this.change} value={this.state.adv_status || ''}>
                                            <option value="0">เลือกสถานะ</option>
                                            <option value="book">จอง</option>
                                            <option value="sign">ทำสัญญา</option>
                                            <option value="transfer">โอน</option>
                                            <option value="expire">หมดประกัน</option>
                                            <option value="insurance">ในประกัน</option>
                                        </select>
                                    </div>
                                </div> */}

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">หมวดเรื่อง :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_category" onChange={this.change} value={this.state.adv_category || ''}>
                                            {this.state.service_category.map((datas) => <option  value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">กลุ่ม :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_group" onChange={this.change} value={this.state.adv_group || ''}>
                                            {this.state.service_group.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">เรื่องย่อย :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_title" onChange={this.change} value={this.state.adv_title || ''}>
                                            {this.state.service_type.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-right">สถานะใบงาน :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_service_status" onChange={this.change} value={this.state.adv_service_status || ''}>
                                            <option value="0">เลือกสถานะใบงาน</option>
                                            <option value="progress">รับเรื่อง</option>
                                            <option value="doing">กำลังดำเนินการ</option>
                                            <option value="cancel">ยกเลิก</option>
                                            <option value="close" className="text-success">จบงาน</option>
                                        </select>
                                    </div>
                                </div>
                            </form>)}
                            {!this.state.matches && (<form>
                                <div className="row mb-3 mt-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">วันที่รับเรื่อง-เริ่มต้น :</div>
                                    <div className="col-sm-7">
                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.adv_startdate} id="adv_startdate" name="adv_startdate" className="form-custom" onChange={this.changeStartDate} dateFormat="dd/MM/yyyy" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">วันที่รับเรื่อง-สิ้นสุด :</div>
                                    <div className="col-sm-7">
                                        <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.adv_enddate} id="adv_enddate" name="adv_enddate" className="form-custom" onChange={this.changeEndDate} dateFormat="dd/MM/yyyy" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">ผู้แจ้ง :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_member" name="adv_member" value={this.state.adv_member || ''} onChange={this.change} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">เบอร์โทรผู้แจ้ง :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_phone" name="adv_phone" value={this.state.adv_phone || ''} onChange={this.change} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">โครงการ :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_project" onChange={this.change} value={this.state.adv_project || ''}>
                                            {this.state.project_home.map((datas, key) => <option key={key} value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">บ้านเลขที่ :</div>
                                    <div className="col-sm-7">
                                        <input type="text" className="form-custom" id="adv_home_number" name="adv_home_number" value={this.state.adv_home_number || ''} onChange={this.change} />
                                    </div>
                                </div>
                                {/* <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">สถานะ :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_status" onChange={this.change} value={this.state.adv_status || ''}>
                                            <option value="0">เลือกสถานะ</option>
                                            <option value="book">จอง</option>
                                            <option value="sign">ทำสัญญา</option>
                                            <option value="transfer">โอน</option>
                                            <option value="expire">หมดประกัน</option>
                                            <option value="insurance">ในประกัน</option>
                                        </select>
                                    </div>
                                </div> */}

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">หมวดเรื่อง :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_category" onChange={this.change} value={this.state.adv_category || ''}>
                                            {this.state.service_category.map((datas) => <option  value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">กลุ่ม :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_group" onChange={this.change} value={this.state.adv_group || ''}>
                                            {this.state.service_group.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">เรื่องย่อย :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_title" onChange={this.change} value={this.state.adv_title || ''}>
                                            {this.state.service_type.map((datas) => <option value={datas.value}>{datas.display}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div htmlFor="username" className="col-sm-3 text-left">สถานะใบงาน :</div>
                                    <div className="col-sm-7">
                                        <select className="form-custom" name="adv_service_status" onChange={this.change} value={this.state.adv_service_status || ''}>
                                            <option value="0">เลือกสถานะใบงาน</option>
                                            <option value="progress">รับเรื่อง</option>
                                            <option value="doing">กำลังดำเนินการ</option>
                                            <option value="cancel">ยกเลิก</option>
                                            <option value="close" className="text-success">จบงาน</option>
                                        </select>
                                    </div>
                                </div>
                            </form>)}

                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-light" onClick={this.clearModal}>เคลียร์</button>
                            <button className="btn btn-danger" onClick={this.closeModal}>ยกเลิก</button>
                            <button className="btn btn-info" onClick={this.submitModal}>ค้นหา</button>
                        </ModalFooter>
                    </Modal>
                </section>
            </div>
        );
    }
}
export default withRouter(DoneCase);
